import { db } from "../../../config/firebaseconfig";


export default function getAllAccountLicenses (id, updateState, licenseType) {
  updateState({loadingLicenses: true})
  return db.collection('accountLicenses').where('accountId', '==', id).get()
    .then(querySnapshot => {
      let licenses = []
      querySnapshot.forEach(doc => doc.exists && licenses.push(doc.data()))
      const filtered = licenses.filter(lic => lic.licenseType === licenseType)
      return updateState({loadingLicenses: false, licenses: filtered})
    })
    .catch(error => updateState({loadingLicenses: false, errorLicenses: error}))
}



// WEBPACK FOOTER //
// ./src/helpers/users/licenses/getAllAccountLicenses.js